module.exports = __webpack_public_path__ + "assets/img/36_563.2c56ae46.jpg";